// extracted by mini-css-extract-plugin
module.exports = {"mainNav":"nav-module--main-nav--3cBeG","socialLinks":"nav-module--social-links--2oA24","social":"nav-module--social--3q7zk","container":"nav-module--container--tGnbG"};